module.exports = __webpack_public_path__ + "static/media/noto-sans-kr-v13-korean-regular.5b2346ef.woff2";